var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"footer blocks"},[_c('div',{staticClass:"container fbox"},[_c('div',{staticClass:"copy"},[_vm._v(" 版权所有 中国国际发展知识中心 京ICP备17048856号 京公网安备 11030102010789号 ")])])])])
}]

export { render, staticRenderFns }